import { LaneHistoryLoad } from 'lib/api/getLaneHistory';
import { Undef } from 'types/UtilityTypes';

/** True when lane history includes sell on at least one load. */
export function laneHistoryShowsSell(loads: LaneHistoryLoad[]): boolean {
  return loads.some((load) => load.totalSell != null);
}

/**
 * True when the API returned per-load margin. The API omits margin for Aljex because its lane-history
 * cost is line haul only while sell is all-in, so sell stays visible there but margin isn't shown.
 * We follow the data here rather than checking the TMS, so the backend owns that rule.
 */
export function laneHistoryShowsMargin(loads: LaneHistoryLoad[]): boolean {
  return loads.some((load) => load.margin != null);
}

/**
 * Display percent for a historical load's margin, in the service's margin vs markup mode.
 * Returns undefined when the load has no margin, or the denominator isn't positive.
 */
export function laneHistoryMarginPercent(
  load: LaneHistoryLoad,
  isGrossMargin: boolean
): Undef<number> {
  const { margin, totalSell, totalCost } = load;
  if (margin == null) {
    return undefined;
  }

  const denominator = isGrossMargin ? totalSell : totalCost;
  if (denominator == null || denominator <= 0) {
    return undefined;
  }

  return (margin / denominator) * 100;
}

/** Format like CarrierPriceCalculator percentage profit (strip trailing .00). */
export function formatLaneHistoryMarginPercent(value: number): string {
  const formatted = value.toFixed(2).replace(/\.?0{2}$/, '');
  return `${formatted}%`;
}
